export function isNumber(str: string | undefined) {
	return !isNaN(Number(str));
}

export function getNumber(str: string | undefined) {
	return isNumber(str) ? Number(str) : -1;
}

export function getGuid() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		const r = (Math.random() * 16) | 0,
			v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}

export function decodeBase64(str: string) {
	if (str) {
		try {
			str = decodeURIComponent(atob(str));
		} catch (error) {
			console.error('Invalid str format:', error);
		}
	}

	return str;
}

export function isValidEmail(email: string | undefined): boolean {
	if (!email) return false;
	// Simple email regex for basic validation
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return re.test(email);
}
